import { Locale } from "@omni/types/enums/locale.enum";

import { values } from "./object.utils";

export const isLocale = (str: string): str is Locale => {
    return !!values(Locale).find((locale) => locale === str);
};

export const getLanguageTag = (locale: Locale) => {
    return locale.replace("_", "-");
};

export const getLanguage = (locale: Locale) => {
    return locale.split("_")[0];
};

export const getLocale = (languageTag: string) => {
    const locale = languageTag.replace("-", "_");

    return isLocale(locale) ? locale : undefined;
};
